export enum WaitForMutationBehaviorEnum {
    SilentOnError,
    ThrowOnError,
}

export interface IBookingMutationWaiter {
    readonly isMutationInProgress: boolean;
    waitForMutation(): Promise<void>;
}
